<template>
  <section class="pricing-tabs-wrapper grey-bg">
    <div class="container">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="Athlete">
          <PricingDetails
            sign-up-link="/register"
            :data="formattedAthletePricingData"
          />
        </a-tab-pane>
        <a-tab-pane key="2" tab="Club Coach">
          <PricingDetails
            sign-up-link="/club-register"
            :data="coachPricingData"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </section>
</template>
<script>
import PricingDetails from "./pricing-details";
import { mapGetters } from "vuex";
const MISC_STORE_KEY = "miscStore";

export default {
  name: "PricingTabs",
  mounted() {
    this.$store.dispatch(`${MISC_STORE_KEY}/getPricing`);
    this.$store.dispatch(`${MISC_STORE_KEY}/getAthletePricing`, {
      type: "player"
    });
    this.$store.dispatch(`${MISC_STORE_KEY}/getpremiumclubHeadCoachPricing`, {
      type: "premiumclubHeadCoach"
    });
    this.$store.dispatch(`${MISC_STORE_KEY}/getFaq`, {
      faqType: "athletePricing"
    });
  },
  computed: {
    ...mapGetters({
      formattedAthletePricingData: `${MISC_STORE_KEY}/formattedAthletePricingData`,
      coachPricingData: `${MISC_STORE_KEY}/formattedPremiumclubHeadCoachPricingData`
    })
  },
  components: {
    PricingDetails
  },
  data() {
    return {};
  },
  methods: {
    callback(key) {
      if (key === "1") {
        this.$store.dispatch(`${MISC_STORE_KEY}/getFaq`, {
          faqType: "athletePricing"
        });
      } else {
        this.$store.dispatch(`${MISC_STORE_KEY}/getFaq`, {
          faqType: "clubCoachPricing"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.pricing-tabs-wrapper {
  padding-bottom: 0;
  .ant-tabs-bar {
    border: none;
    display: flex;
    justify-content: center;
  }
  .ant-tabs-nav-wrap {
    margin-bottom: 0;
  }
  .ant-tabs-nav {
    .ant-tabs-ink-bar {
      display: none !important;
    }
    > div {
      .ant-tabs-tab {
        margin: 0;
        font-family: $content-font;
        font-size: 16px;
        text-transform: uppercase;
        color: #212164;
        padding: 10px 30px;
        font-weight: 500;
        border: 2px solid #212164;
        &.ant-tabs-tab-active {
          background: #212164;
          color: #ffffff;
        }
        &:first-child {
          border-radius: 5px 0 0 5px;
          border-right-width: 1px;
        }
        &:last-child {
          border-radius: 0 5px 5px 0;
          border-left-width: 1px;
        }
      }
    }
  }
}
</style>
